export default "__VITE_ASSET__iwitz4_O__"